import { useState } from 'react';
import { Alert, Button, Card, Stack, Text, TextInput, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';

import { unwrap } from '../../api/client';
import { setParentPin } from '../../api/gen';
import { useOrg, useSession } from '../../lib/session';

// The parent PIN, and the one honest sentence about what it is for.
export function SecurityPage() {
  const org = useOrg();
  const { unpair } = useSession();
  const [pin, setPin] = useState('');

  const save = useMutation({
    mutationFn: () => unwrap(setParentPin({ headers: org, body: { pin } })),
    onSuccess: () => {
      setPin('');
      notifications.show({ message: 'Eltern-PIN gespeichert.' });
    },
    onError: (err) => notifications.show({ color: 'red', message: (err as Error).message }),
  });

  return (
    <Stack>
      <Title order={3}>Sicherheit</Title>

      <Card withBorder padding="lg">
        <Stack>
          <Text fw={600}>Eltern-PIN</Text>
          <Text size="sm" c="dimmed">
            Sie schützt den Eltern-Modus auf einem Gerät, das Kinder benutzen. Sie meldet
            niemanden an — vier Ziffern, die das könnten, wären ein vierstelliges Passwort.
          </Text>
          <TextInput
            label="Neue PIN"
            inputMode="numeric"
            maxLength={4}
            value={pin}
            onChange={(e) => setPin(e.currentTarget.value.replace(/\D/g, ''))}
          />
          <Button disabled={pin.length !== 4} loading={save.isPending} onClick={() => save.mutate()}>
            Speichern
          </Button>
        </Stack>
      </Card>

      <Card withBorder padding="lg">
        <Stack align="start">
          <Text fw={600}>Dieses Gerät</Text>
          <Text size="sm" c="dimmed">
            Trennt das Tablet von der Familie. Die Kinderprofile bleiben bestehen; dieses Gerät
            vergisst sie nur und fragt beim nächsten Mal wieder nach einer Anmeldung.
          </Text>
          <Alert variant="light" color="gray" w="100%">
            Die Anmeldung eines Elternteils gilt ohnehin nur für diesen Tab. Was das Gerät über
            die Familie behält, sind die Namen der Kinder — kein Zugang.
          </Alert>
          <Button color="red" variant="light" onClick={unpair}>
            Gerät trennen
          </Button>
        </Stack>
      </Card>
    </Stack>
  );
}
